import { forwardRef, memo } from 'react';
import { Input } from 'antd';

const CustomTextArea = ({ adjustPosition, idOfAdjustPositionByScroll, ...props }: any, ref: any) => {
    return <Input.TextArea {...props} ref={ref} />;
};

export default memo(forwardRef(CustomTextArea));
